<template>
    <div
        class="modal fade"
        id="modalCreateAssetId"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalCreateAssetIdLabel"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content asset-id-modal">
                <div class="modal-header border-0 pb-0">
                    <div class="d-flex align-items-start header-info">
                        <span class="warning-icon-wrapper">
                            <span class="warning-icon">&#9888;</span>
                        </span>
                        <div>
                            <h5 class="modal-title" id="modalCreateAssetIdLabel">Tentukan Asset ID</h5>
                            <p class="modal-subtitle mb-0">
                                SN tidak tersedia di Jurnal. Masukkan Asset ID secara manual untuk item ini.
                            </p>
                        </div>
                    </div>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <hr class="modal-divider">

                <div class="modal-body pt-0">
                    <div class="item-info-box">
                        <div class="row no-gutters">
                            <div class="col-5">
                                <div class="info-label">Serial Number</div>
                                <div class="info-value">{{ item.reference || '-' }}</div>
                            </div>
                            <div class="col-7">
                                <div class="info-label">Nama Item</div>
                                <div class="info-value">{{ item.itemName || '-' }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="asset-id-field mt-3">
                        <label class="asset-id-label" for="assetIdInput">Asset ID</label>
                        <input
                            id="assetIdInput"
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            class="form-control asset-id-input"
                            :value="assetId"
                            @input="handleAssetIdInput"
                            placeholder="Masukkan Asset ID"
                        >
                    </div>
                </div>

                <hr class="modal-divider">

                <div class="modal-footer border-0 pt-0">
                    <button type="button" class="btn btn-outline-secondary btn-batal" @click="closeModal">
                        Batal
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary btn-simpan"
                        :disabled="!assetId.trim() || loading"
                        @click="simpan"
                    >
                        {{ loading ? 'Menyimpan...' : 'Simpan' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalCreateAssetId',
    data() {
        return {
            item: {},
            assetId: '',
            loading: false,
        };
    },
    methods: {
        showModal(item) {
            this.item = item || {};
            this.assetId = '';
            this.loading = false;
            $(this.$refs.modal).modal('show');
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
        },
        handleAssetIdInput(event) {
            const sanitized = event.target.value.replace(/\D/g, '');
            event.target.value = sanitized;
            this.assetId = sanitized;
        },
        simpan() {
            if (!this.assetId.trim() || this.loading) return;
            this.$emit('simpan', { item: this.item, assetId: this.assetId.trim() });
        },
    },
    beforeDestroy() {
        $(this.$refs.modal).modal('hide');
    },
};
</script>

<style scoped>
.asset-id-modal {
    border-radius: 16px;
    border: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.modal-header {
    padding: 1.5rem 1.5rem 0;
    align-items: flex-start;
}

.header-info {
    gap: 12px;
}

.warning-icon-wrapper {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #fdecea;
    display: flex;
    align-items: center;
    justify-content: center;
}

.warning-icon {
    color: #dc3545;
    font-size: 20px;
    line-height: 1;
}

.modal-title {
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    margin-bottom: 6px;
}

.modal-subtitle {
    font-size: 13px;
    color: #6c757d;
    line-height: 1.5;
}

.modal-divider {
    margin: 1rem 0;
    border-top: 1px solid #e9ecef;
}

.modal-body {
    padding: 0 1.5rem;
}

.item-info-box {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 14px 16px;
}

.info-label {
    font-size: 11px;
    font-weight: 600;
    color: #868e96;
    margin-bottom: 4px;
}

.info-value {
    font-size: 14px;
    color: #212529;
    font-weight: 600;
    line-height: 1.4;
}

.asset-id-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #212529;
    margin-bottom: 8px;
}

.asset-id-input {
    font-size: 14px;
    padding: 10px 14px;
    height: auto;
    border-radius: 6px;
    border: 1px solid #ced4da;
}

.asset-id-input:focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}

.modal-footer {
    padding: 0 1.5rem 1.5rem;
    gap: 8px;
}

.btn-batal {
    font-size: 13px;
    padding: 6px 20px;
    border-color: #dee2e6;
    color: #343a40;
}

.btn-simpan {
    font-size: 13px;
    padding: 6px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Disposal/CustomComponent/ModalCreateAssetId.vue